(ns toe-prepare.config)
; !!! GENERATED DO NOT EDIT !!!
(def config
{:lr-feed-news "https://example.com",
 :client "tb",
 :keycloak-url "http://localhost:9393/realms/teamoesterreich",
 :lr-feed-faq "https://example.com",
 :google-maps-api "",
 :firebase-config {},
 :backend-server-url "http://localhost:8083/admin-app-services",
 :keycloak-client-id "toe-admin",
 :client-url "http://localhost:8888/",
 :websocket-server-url "ws://localhost:8083/event-socket"}
)